<template>
  <div>
    <v-container fluid>
      <v-row>
         <v-col cols="12" v-if="!soloLectura" style="display: flex;
    justify-content: end;">
          <v-btn small color="teal" dark @click="agregar = true"
            >Agregar proyecto</v-btn>
        </v-col>
        <v-col cols="12" v-for="proyecto in proyectos" :key="proyecto._id">
          <v-card outlined>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  <a @click="verProyecto(proyecto._id)"
                    ><h2>Proyecto {{ proyecto.numero }}</h2></a
                  >
                </v-list-item-title>
                <v-list-item-subtitle>
                  <h3>{{ proyecto.nombre }}</h3>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action
                ><h1>{{ moneda(proyecto.montoTotal) }}</h1></v-list-item-action
              >
            </v-list-item>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Número</th>
                    <th class="text-left">Objetivo</th>
                    <th class="text-left">Presupuesto</th>
                    <th class="text-left">Modificado</th>
                    <th class="text-left">Comprometido</th>
                    <th class="text-left">Ejercido</th>
                    <th class="text-left">Comprobado</th>
                    <th class="text-left">Disponible</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="objetivo in proyecto.objetivoParticular"
                    :key="objetivo._id"
                  >
                    <td>{{ objetivo.numero }}</td>
                    <td>{{ objetivo.nombre }}</td>
                    <td>{{ moneda(objetivo.presupuesto) }}</td>
                    <td>{{ moneda(objetivo.modificado) }}</td>
                    <td>{{ moneda(objetivo.comprometido) }}</td>
                    <td>{{ moneda(objetivo.ejercido) }}</td>
                    <td>{{ moneda(objetivo.comprobado) }}</td>
                    <td>{{ moneda(objetivo.disponible) }}</td>
                  </tr>
                  <tr class="columna">
                    <td></td>
                    <td align="right"><h3>Total</h3></td>
                    <td>
                      <span
                        :class="{
                          'red-text':
                            proyecto.presupuestoTotal != proyecto.montoTotal,
                        }"
                        ><h3>{{ moneda(proyecto.presupuestoTotal) }}</h3></span
                      >
                    </td>
                    <td>
                      <h3>{{ moneda(proyecto.modificadoTotal) }}</h3>
                    </td>
                    <td>
                      <h3>{{ moneda(proyecto.comprometidoTotal) }}</h3>
                    </td>
                    <td>
                      <h3>{{ moneda(proyecto.ejercidoTotal) }}</h3>
                    </td>
                    <td>
                      <h3>{{ moneda(proyecto.comprobadoTotal) }}</h3>
                    </td>
                    <td>
                      <h3>{{ moneda(proyecto.disponibleTotal) }}</h3>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
       
      </v-row>
    </v-container>

    <agregar-proyecto
      v-if="agregar"
      :mostrar="agregar"
      @cancelar="agregar = false"
      @proyectoAgregado="proyectoAgregado"
    />
  </div>
</template>

<script>
const numeral = require("numeral");
import axios from "axios";
import { mapGetters } from "vuex";
import AgregarProyecto from "../components/proyectos/agregarProyecto";

export default {
  components: { AgregarProyecto },
  computed: {
    ...mapGetters(["httpURL", "sessionToken", "soloLectura"]),
  },
  data() {
    return {
      loading: false,
      search: null,
      agregar: false,
      title: "Proyectos",
      headers: [
        { text: "Número", value: "numero", sortable: true },
        { text: "Año", value: "anio", sortable: true },
        { text: "Nombre", value: "nombre", sortable: true },
        { text: "Monto", value: "monto", sortable: true },
      ],
      proyectos: [],
    };
  },
  created() {
    this.loading = true;
    axios
      .get(this.httpURL + "/proyectos", {
        headers: { token: this.sessionToken },
      })
      .then((res) => {
        // console.log(res.data);
        if (res.data.ok) {
          this.proyectos = res.data.proyectos;
        } else
          this.$notify({
            group: "gral_notif",
            type: "error",
            duration: 1500,
            speed: 500,
            text: res.data.mensaje,
          });
        this.loading = false;
      })
      .catch((error) => {
        // console.log('Error: '+error);
        this.$notify({
          group: "gral_notif",
          type: "error",
          duration: 1500,
          speed: 500,
          text: "Ocurrió un error al hacer la petición",
        });
        this.loading = false;
      });
  },
  methods: {
    moneda(numero) {
      const options2 = { style: "currency", currency: "USD" };
      const numberFormat2 = new Intl.NumberFormat("en-US", options2);
      if(numero<0.01) return (numberFormat2.format(0));
      return (numberFormat2.format(numero));
    },
    verProyecto(id) {
      this.$router.push("./proyecto/" + id);
    },
    proyectoAgregado(proyecto) {
      this.proyectos.push(proyecto);
      this.agregar = false;
    },
  },
};
</script>

<style>
.red-text {
  color: red;
}
.columna {
  background-color: #cef3ee;
}
</style>
